import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 1c4.96 0 9 4.04 9 9s-4.04 9-9 9-9-4.04-9-9 4.04-9 9-9z',
    'M15.66 4.34L10 10l6.18 5.08C17.32 13.7 18 11.93 18 10c0-2.21-.9-4.21-2.34-5.66z',
  ],
  height: 20,
  width: 20,
});
